import { render, staticRenderFns } from "./bnvbase.vue?vue&type=template&id=e10529a2&"
import script from "./bnvbase.vue?vue&type=script&lang=js&"
export * from "./bnvbase.vue?vue&type=script&lang=js&"
import style0 from "./bnvbase.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports